import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7e87181d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tab-content d-overflow" }

import { ref, onMounted, watch } from "vue";
import { useRoute, useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'Home',
  setup(__props) {

//  活动预约 -主页
const route = useRoute();
const router = useRouter();
onMounted(() => {
  if (!route.params.active) {
    // 没有值设置一个默认值
    change('all');
  }
  watch(() => route.params, () => {
    if (route.params.active != active.value && route.params.active) {
      active.value = route.params?.active[0] as string;
    }
  })
})

const tabsData = ref([
  { title: '全部', name: 'all' },
  { title: '预约中', name: 'progress' },
  { title: '已结束', name: 'finish' },

]);
const active = ref(route.params.active[0]);

const change = (active) => {
  router.replace({ name: route.name, params: { active: active } });
}

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_van_tab = _resolveComponent("van-tab")!
  const _component_van_tabs = _resolveComponent("van-tabs")!

  return (_openBlock(), _createBlock(_component_van_tabs, {
    "title-active-color": "#ff6d19",
    class: "tab",
    active: active.value,
    "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((active).value = $event)),
    animated: "",
    onChange: change,
    swipeable: ""
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabsData.value, (item) => {
        return (_openBlock(), _createBlock(_component_van_tab, {
          name: item.name,
          key: item.name,
          title: item.title
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_router_view, {
                name: item.name,
                title: item.title
              }, null, 8, ["name", "title"])
            ])
          ]),
          _: 2
        }, 1032, ["name", "title"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["active"]))
}
}

})